@if(visible()){
<div class="jk-combobox-border" [ngStyle]="flexStyle">
  <div>
    <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
      [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  </div>
  <div>
    <!-- <mat-button-toggle-group [(ngModel)]="value" (valueChange)="onValueChange($event)" -->
    <mat-button-toggle-group [(value)]="value" (valueChange)="onValueChange($event)" [disabled]="disabled()"
      [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()">
      @for (idNameItem of items(); track idNameItem) {
      <mat-button-toggle [value]="idNameItem.id">
        {{ idNameItem.name }}
      </mat-button-toggle>
      }
    </mat-button-toggle-group>

    <!--
    [hideMultipleSelectionIndicator]="hideMultipleSelectionIndicator"
    <button mat-raised-button color="primary" (click)="onSubmit()">Submit</button> -->
    <!-- <div>{{selectedItem.name}}</div> -->

  </div>

</div>
}